/**
 * D6 — o "% conectado" no card do monitorador (a faixa inteira mora na gaveta). Uma linha:
 * "Conectado 98,7% dos últimos 30 dias". O número vem pronto do servidor; sem medição é "—"
 * com o motivo, nunca 100%.
 */
import { NO_DATA_DASH, Skeleton, formatPercent } from '@mgdlead/ui';

import { useWorkspace } from '../../../features/workspace/WorkspaceContext';
import { useMonitorActivity } from '../../../lib/api';

export function UptimeLine({ monitorId }: { monitorId: string }) {
  const { workspace } = useWorkspace();
  const atividade = useMonitorActivity(workspace.id, monitorId, true);

  if (atividade.isPending) return <Skeleton className="mt-3 h-3.5 w-48" />;
  if (atividade.isError || !atividade.data) return null;

  const { uptime, dias } = atividade.data;
  return (
    <p className="mt-3 text-xs text-muted-foreground">
      {uptime.fracao === null ? (
        <>
          <span aria-hidden="true" className="nums text-foreground">
            {NO_DATA_DASH}
          </span>{' '}
          Ainda sem medição de conexão.
        </>
      ) : (
        <>
          Conectado{' '}
          <span className="nums font-medium text-foreground">
            {formatPercent(uptime.fracao, 1)}
          </span>{' '}
          dos últimos {dias.length} dias
          {uptime.diasSemRegistro > 0 ? (
            <span className="text-subtle-foreground">
              {' '}
              · {uptime.diasSemRegistro} {uptime.diasSemRegistro === 1 ? 'dia' : 'dias'} sem
              registro
            </span>
          ) : null}
        </>
      )}
    </p>
  );
}
